"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberField = void 0;
const react_1 = __importDefault(require("react"));
const rifm_1 = require("rifm");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const number_adapter_hook_1 = require("../../utils/number-adapter-hook");
const internal_state_hook_1 = require("../../utils/internal-state-hook");
const text_field_1 = require("../text-field/text-field");
function NumberField({ value: providedValue = null, onChange: providedOnChange, negative = false, formated = false, maxValue, minValue, ...props }) {
    const adapter = number_adapter_hook_1.useNumberAdapter(providedValue, providedOnChange);
    const valueCondition = event_callback_hook_1.useEventCallback((value, externalValue) => {
        return value !== externalValue;
    });
    const changeCondition = event_callback_hook_1.useEventCallback((value) => {
        if (value === '') {
            return true;
        }
        else {
            const number = Number(value);
            if (!Number.isNaN(number)) {
                if (maxValue && number > maxValue) {
                    return false;
                }
                else if (minValue && number < minValue) {
                    return false;
                }
                else {
                    return true;
                }
            }
            else {
                return false;
            }
        }
    });
    const [value, setValue, synced] = internal_state_hook_1.useInternalState(adapter, valueCondition, changeCondition);
    const handleChange = event_callback_hook_1.useEventCallback((value) => setValue(negative ? parseNegative(value) : parseInteger(value)));
    const accept = negative ? negativeAccept : integerAccept;
    const format = negative
        ? formated
            ? formatNegativeSeparator
            : formatNegative
        : formated
            ? formatIntegerSeparator
            : formatInteger;
    const rifm = rifm_1.useRifm({
        accept,
        format,
        value,
        onChange: handleChange,
    });
    return (react_1.default.createElement(text_field_1.TextField, Object.assign({ value: rifm.value, onChangeEvent: rifm.onChange, error: !synced }, props)));
}
exports.NumberField = NumberField;
const integerAccept = /\d+/g;
function parseInteger(str) {
    return (str.match(integerAccept) || []).join('');
}
function formatInteger(str) {
    const parsed = parseInteger(str);
    const number = Number.parseInt(parsed, 10);
    if (Number.isNaN(number)) {
        return '';
    }
    return number.toString();
}
function formatIntegerSeparator(str) {
    const parsed = parseInteger(str);
    const number = Number.parseInt(parsed, 10);
    if (Number.isNaN(number)) {
        return '';
    }
    return number.toLocaleString('cs');
}
const negativeAccept = /[\d-]+/g;
function parseNegative(str) {
    return (str.match(negativeAccept) || []).join('');
}
function formatNegative(str) {
    const parsed = parseNegative(str);
    if (parsed === '-') {
        return '-';
    }
    const number = Number.parseInt(parsed, 10);
    if (Number.isNaN(number)) {
        return '';
    }
    return number.toString();
}
function formatNegativeSeparator(str) {
    const parsed = parseNegative(str);
    if (parsed === '-') {
        return '-';
    }
    const number = Number.parseInt(parsed, 10);
    if (Number.isNaN(number)) {
        return '';
    }
    return number.toLocaleString('cs');
}
//# sourceMappingURL=number-field.js.map